"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToShortMemory = exports.BYTES_IN_GB = exports.BYTES_IN_MB = exports.BYTES_IN_KB = exports.AdminMGTProvider = exports.useAdminMGTContext = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const lodash_1 = __importDefault(require("lodash"));
const use_custom_compare_1 = require("use-custom-compare");
const Commons_1 = require("src/configeek_assets/src/components/common/provider/Commons");
const ActorsProvider_1 = require("src/configeek_assets/src/components/common/provider/ActorsProvider");
const isMounted_1 = __importDefault(require("src/configeek_assets/src/system/hooks/isMounted"));
const DateTimeUtils_1 = require("src/configeek_assets/src/system/mics/DateTimeUtils");
const initialContextValue = {
    validation: { validated: false, valid: false },
    mgtInfo: (0, Commons_1.getDefaultCGFeature)(),
    checkHasAccess: () => undefined,
    getInformation: () => undefined,
};
const AdminMGTContext = React.createContext(initialContextValue);
const useAdminMGTContext = () => React.useContext(AdminMGTContext);
exports.useAdminMGTContext = useAdminMGTContext;
const AdminMGTProvider = (props) => {
    const actorsContext = (0, ActorsProvider_1.useActorsContext)();
    const isMounted = (0, isMounted_1.default)();
    const checkHasAccess = (0, react_1.useCallback)(async () => {
        const get = async () => {
            try {
                const managementActor = await actorsContext.getManagementActor();
                if (managementActor) {
                    const result = await managementActor.mgt_hasAccess();
                    updateValidationStatus({ validated: true, valid: result });
                }
            }
            catch (e) {
                console.warn("adminMGT_hasAccess failed", e);
                updateValidationStatus({ validated: true, valid: false });
            }
        };
        // noinspection ES6MissingAwait
        get();
    }, [isMounted, actorsContext.getManagementActor]);
    const getInformation = (0, react_1.useCallback)(async () => {
        const get = async () => {
            updateMgtInfoFeature({ status: { inProgress: true } });
            try {
                const managementActor = await actorsContext.getManagementActor();
                if (process.env.NODE_ENV === "development") {
                    console.log("AdminMGTProvider.getInformation!", managementActor);
                }
                if (managementActor) {
                    let result = await managementActor.mgt_getInformation();
                    if (!!process.env.IS_TEST_SERVER) {
                        console.log("adminMGT_getInformation: response", result);
                    }
                    if (isMounted()) {
                        try {
                            const resultParsed = JSON.parse(result);
                            if (process.env.NODE_ENV === "development") {
                                console.log("adminMGT_getInformation: response JSON", resultParsed);
                            }
                            updateMgtInfoFeature({
                                status: { inProgress: false, loaded: true },
                                error: { error: undefined, isError: false, },
                                data: resultParsed,
                                time: { updatedAt: DateTimeUtils_1.DateTimeUtils.now() }
                            });
                        }
                        catch (e) {
                            console.warn("adminMGT_getInformation failed: parsing error", e);
                            updateMgtInfoFeature({
                                status: { inProgress: false, loaded: true },
                                error: { error: e, isError: true },
                                data: undefined,
                            });
                        }
                    }
                }
                else {
                    if (isMounted()) {
                        updateMgtInfoFeature({ status: { inProgress: false } });
                    }
                }
            }
            catch (e) {
                console.warn("adminMGT_getInformation failed: network error", e);
                if (isMounted()) {
                    updateMgtInfoFeature({
                        status: { inProgress: false, loaded: true },
                        error: { error: e, isError: true },
                        data: undefined,
                    });
                }
            }
        };
        // noinspection ES6MissingAwait
        get();
    }, [isMounted]);
    const [validationStatus, updateValidationStatus] = (0, react_1.useReducer)((state, newState) => ({ ...state, ...newState }), lodash_1.default.cloneDeep(initialContextValue.validation));
    const [mgtInfoFeature, updateMgtInfoFeature] = (0, react_1.useReducer)(Commons_1.simpleFeatureReducer, initialContextValue.mgtInfo);
    const value = (0, use_custom_compare_1.useCustomCompareMemo)(() => ({
        validation: validationStatus,
        mgtInfo: mgtInfoFeature,
        checkHasAccess: checkHasAccess,
        getInformation: getInformation,
    }), [
        validationStatus,
        mgtInfoFeature,
        checkHasAccess,
        getInformation,
    ], (prevDeps, nextDeps) => {
        return lodash_1.default.isEqual(prevDeps, nextDeps);
    });
    return React.createElement(AdminMGTContext.Provider, { value: value }, props.children);
};
exports.AdminMGTProvider = AdminMGTProvider;
exports.BYTES_IN_KB = 1024;
exports.BYTES_IN_MB = 1024 * exports.BYTES_IN_KB;
exports.BYTES_IN_GB = 1024 * exports.BYTES_IN_MB;
const formatToShortMemory = (value) => {
    if (value >= exports.BYTES_IN_GB) {
        const gb = (value / exports.BYTES_IN_GB).toFixed(0);
        return `${gb} GB`;
    }
    if (value >= exports.BYTES_IN_MB) {
        const mb = (value / exports.BYTES_IN_MB).toFixed(0);
        return `${mb} MB`;
    }
    if (value >= exports.BYTES_IN_KB) {
        const kb = (value / exports.BYTES_IN_KB).toFixed(0);
        return `${kb} KB`;
    }
    return `${value} B`;
};
exports.formatToShortMemory = formatToShortMemory;
